import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

/**
 * Handles return from Emergent OAuth. URL fragment contains #session_id=...
 */
export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      nav("/login");
      return;
    }
    const sessionId = m[1];
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        setUser(data);
        // Clean URL fragment, then go to dashboard
        window.history.replaceState(null, "", "/dashboard");
        nav("/dashboard", { replace: true });
      } catch (e) {
        nav("/login");
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="font-heading text-2xl uppercase tracking-tight animate-pulse">Securing your session…</div>
        <div className="mt-2 text-sm font-mono text-zinc-500">◢ verifying credentials</div>
      </div>
    </div>
  );
}
